module.exports = __webpack_public_path__ + "static/media/empa_logo.9c539ee7.jpeg";